module.exports = __webpack_public_path__ + "static/media/pred.bfb1b91c.png";